import { RateGroup } from "@/helpers/types/types.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useShallow } from "zustand/react/shallow";

/**
 * Check if the current RateGroup is disabled due to maxAvailability
 */
export const useCheckAccommodationAvailibility = (currentRG: RateGroup): boolean => {
  const { availableRateGroups, cartAccommodationItems } = useEngineStore(
    useShallow((state) => ({
      availableRateGroups: state.availableRateGroups,
      cartAccommodationItems: state.cartAccommodationItems,
    })),
  );

  const mappedCartItemAvailability = availableRateGroups
    ?.map((rg) => {
      const matchingCartItems = cartAccommodationItems?.length
        ? cartAccommodationItems?.filter((item) => item.rateGroup.id === rg.id)
        : [];
      if (matchingCartItems.length) {
        return { rateGroup: rg, amountInCart: matchingCartItems.length };
      }
      return;
    })
    ?.filter((item) => item);
  const RPDisabled = mappedCartItemAvailability?.find(
    (item) => currentRG.id === item?.rateGroup.id && item.amountInCart >= item.rateGroup.maxAvailability,
  );

  return Boolean(RPDisabled) || !currentRG.maxAvailability;
};
